import PinList from "@/components/PinList";
import { EVENT } from "@/constants/event";
import { getBoardPins } from "@/services";
import { useInfiniteList } from "@/utils/hooks/useInfiniteList";
import { useEventListener, useMemoizedFn } from "ahooks";
import { last } from "lodash";
import { useRef } from "react";

const PIN_SIZE_PER_REQUEST = 40; // 采集列表，每次请求的分页大小

interface BoardPinListProps {
  board: IBoardInfo;
  isNew?: boolean;
  serverSidePins?: IPin[];

  query?: {
    sort?: string;
    color?: string;
    fileType?: string;
    resolution?: string;
    time?: string;
    viewType?: string;
    page?: number;
    pageSize?: number;
    viewSource?: string;
  };
}

export function BoardPinList({ board, serverSidePins }: BoardPinListProps) {
  const initPins = serverSidePins || board.pins;
  const boardId = board?.board_id;
  const maxRef = useRef(last(serverSidePins)?.pin_id);
  const pinRef = useRef();

  const queryFn = useMemoizedFn(async () => {
    const res = await getBoardPins({
      board_id: boardId,
      limit: PIN_SIZE_PER_REQUEST,
      max: maxRef.current,
    });

    maxRef.current = last(res?.pins)?.pin_id || maxRef.current;

    return res?.pins || [];
  });

  const {
    list: dataSource,
    hasMore,
    onLoadMore,
    setList,
  } = useInfiniteList(queryFn, {
    initialData: initPins,
  });

  // 监听采集移动事件
  useEventListener(EVENT.CHANGE_PIN_BOARD, (evt) => {
    if (evt?.detail?.originBoardId === boardId) {
      setList((dataSource) =>
        dataSource.filter((record) => record.pin_id !== evt?.detail?.pinId)
      );
    }
  });

  return (
    <div ref={pinRef}>
      <PinList
        dataSource={dataSource}
        hasMore={hasMore}
        hideUser={true}
        showBoardLink={false}
        onLoadMore={onLoadMore}
        masonryKey="BoardPinList"
      ></PinList>
    </div>
  );
}
